import styled, { keyframes } from 'styled-components';

import { modernTheme } from '@modern/theme/modern-theme';

const { color } = modernTheme;

const pulse = keyframes`
  0%, 100% { opacity: 0.25; }
  50% { opacity: 1; }
`;

// Fixed, not 100vh: the gate renders this before ModernGlobalStyle applies, so
// the body still has its default margin and a viewport-height box scrolled.
export const ModernSplashScreen = styled.div`
  position: fixed;
  display: grid;
  inset: 0;
  place-items: center;
  background: ${color.surface.canvas};
`;

export const ModernSplashMark = styled.span`
  display: block;
  width: 2rem;
  height: 0.125rem;
  background: ${color.accent.base};
  animation: ${pulse} 1.1s ease-in-out infinite;
`;
